import React from "react";

import {
  Box,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow
} from "@mui/material";
import { useDevice } from "hooks";

import { AiDataTableRow } from "./components/AiDataTableRow";
import { useAiDataContext } from "./context/AiData-context";
import { ParameterTable } from "./ParameterTable";

interface Props {
  hidePagination?: boolean;
}

export const AiDataTable: React.FC<Props> = ({ hidePagination = false }) => {
  const {
    recommendationsTable,
    expandedRows,
    generateUniqueId,
    pagination,
    handleChangePage,
    handleChangeRowsPerPage
  } = useAiDataContext();

  const { isMobile } = useDevice();

  return (
    <>
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          position: "relative",
          overflow: "auto",
          border: "1px solid #DBE8F5",
          borderRadius: "8px",
          "& .MuiTable-root": {
            borderCollapse: "separate",
            borderSpacing: 0
          },
          "& .MuiTableHead-root .MuiTableCell-root": {
            backgroundColor: "#F7FAFD"
            // borderBottom: "1px solid #DBE8F5"
          },
          "& .MuiTableBody-root .MuiTableCell-root": {
            borderBottom: "1px solid #DBE8F5"
          },
          "& .MuiTableCell-root": {
            padding: "6px 16px"
          }
        }}
      >
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: "25px !important", padding: "0px 16px !important", height: "40px" }}></TableCell>
              <TableCell sx={{ padding: "0px 16px !important", height: "40px", fontSize: "16px" }}>File</TableCell>
              <TableCell sx={{ padding: "0px 16px !important", height: "40px", fontSize: "16px" }}>Deal</TableCell>
              <TableCell sx={{ padding: "0px 16px !important", height: "40px", fontSize: "16px" }}>Scan Date</TableCell>
              <TableCell
                sx={{ padding: "0px 16px !important", height: "40px", whiteSpace: "nowrap", fontSize: "16px" }}
              >
                # of Items
              </TableCell>
              <TableCell sx={{ padding: "0px 16px !important", height: "40px", fontSize: "16px" }}></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {recommendationsTable?.map((row) => (
              <React.Fragment key={generateUniqueId(row, row.file.id)}>
                <AiDataTableRow row={row} fileId={row.file.id} />
                {expandedRows.has(generateUniqueId(row, row.file.id)) && row.children?.length && (
                  <ParameterTable row={row.children} dealId={row?.deal?.id} fileId={row.file.id} />
                )}
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {!hidePagination && pagination && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: isMobile ? "center" : "flex-end"
          }}
        >
          {isMobile ? (
            <Pagination
              variant="outlined"
              color="primary"
              count={pagination.last_page}
              page={pagination.current_page}
              onChange={(_, newPage) => handleChangePage(newPage)}
            />
          ) : (
            <TablePagination
              labelRowsPerPage="Rows Per Page"
              rowsPerPageOptions={[10, 25, 50, 100]}
              component="div"
              count={pagination.total}
              rowsPerPage={pagination.per_page}
              page={pagination.current_page - 1}
              onPageChange={(_, newPage) => handleChangePage(newPage + 1)}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{ overflow: "hidden", ".MuiTablePagination-toolbar": { minHeight: "32px" } }}
            />
          )}
        </Box>
      )}
    </>
  );
};
